const APP_NAME = 'Finvu Web';

export const getPageTitle = (pathname) => {
	if (pathname === '/' || pathname.startsWith('/login')) {
		return `Login — ${APP_NAME}`;
	}
	if (pathname === '/home') {
		return `Home — ${APP_NAME}`;
	}
	if (pathname === '/voice-journey') {
		return `Voice Journey — ${APP_NAME}`;
	}
	if (pathname.startsWith('/accounts/')) {
		return `Account Discovery — ${APP_NAME}`;
	}
	if (pathname === '/payment-consent') {
		return `Consent — ${APP_NAME}`;
	}
	if (pathname.startsWith('/NoAccountFound/')) {
		return `Add Account — ${APP_NAME}`;
	}
	if (pathname === '/exit') {
		return `Exit — ${APP_NAME}`;
	}
	if (pathname === '/error') {
		return `Error — ${APP_NAME}`;
	}
	if (pathname === '/consent-status') {
		return `Consent Status — ${APP_NAME}`;
	}
	if (pathname === '/consent-renew') {
		return `Consent Renewal — ${APP_NAME}`;
	}
	if (pathname === '/consent-renew-status') {
		return `Consent Renewal Status — ${APP_NAME}`;
	}
	return APP_NAME;
};

export const setPageTitle = (pathname) => {
	document.title = getPageTitle(pathname);
};
